import { styled } from '@material-ui/core';

export const VideoItemContainer = styled('div')(({ theme }) => ({
  width: '100%',
  position: 'relative',
}));

export const ThumbnailContainer = styled('div')(({ theme }) => ({
  overflow: 'hidden',
  width: '100%',
  height: 112,
  borderRadius: 8,
  position: 'relative',
  '&:before': {
    content: '""',
    width: '100%',
    height: '100%',
    display: 'block',
    position: 'absolute',
    left: 0,
    top: 0,
    backgroundColor: 'rgba(0,0,0,0.6)',
  },
}));

export const Thumbnail = styled('img')(({ theme }) => ({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'top center',
}));

export const FloatingContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  left: '95%',
  top: '95%',
  transform: 'translate(-95%,-95%)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));
